import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { initialize, Field, reduxForm } from "redux-form";
import ManageFormHeader from "../../components/base/ManageFormHeader";
import {
  CreateUser,
  EditUser,
  GetUser,
} from "../../infra/requests/UsersRequests";
import FormValidator from "../../infra/services/validations/FormValidator";
import { BaseForm, FormContainer, SpinLoading } from "../../styles/BasicStyles";
import { FlattenToFormData } from "../../infra/services/formdata/TransformToFormData";
import { Col, Row } from "antd";
import TextInput from "../../components/generic/inputs/TextInput";

const validations = FormValidator.make({
  name: "required",
  country: "required",
  address: "required",
  city: "required",
  postal_code: "required",
});

class ManageAdminPage extends Component {
  state = {
    isNew: false,
    loading: true,
    ready: false,
    info: {},
  };

  componentDidMount = async () => {
    const {
      match: { params },
      dispatch,
    } = this.props;

    if (params.id) {
      const result = await GetUser(params.id);
      dispatch(initialize("manage_admin_form", { ...result.data }));

      this.setState({
        ready: true,
        loading: false,
        isNew: false,
        info: result || {},
      });
    } else {
      this.setState({
        loading: false,
        ready: true,
        isNew: true,
      });
    }
  };

  onSubmit = async (values) => {
    try {
      this.setState({ loading: true });
      const {
        match: { params },
        history,
      } = this.props;
      const { isNew } = this.state;

      if (values.image && !values.image.blob) {
        delete values.image;
      }

      const payload = FlattenToFormData({ ...values });
      isNew ? await CreateUser(payload) : await EditUser(params.id, payload);
      this.setState({ loading: false });
      return history.push("/administrators");
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };

  handleOnCancel = async () => {
    const { history } = this.props;
    return history.push("/administrators");
  };

  render() {
    const { handleSubmit, pristine } = this.props;
    const { isNew, ready, loading } = this.state;

    if (!ready) return <SpinLoading />;
    const title = isNew ? "Add" : "Edit";

    return (
      <React.Fragment>
        <ManageFormHeader
          titles={["Administrators", title]}
          buttons={[
            {
              type: "primary",
              icon: "save",
              text: "Save",
              onClick: handleSubmit((values) => this.onSubmit(values, false)),
              disabled: pristine,
              loading,
            },
            {
              type: "default",
              icon: "close",
              text: "Cancel",
              onClick: this.handleOnCancel,
            },
          ]}
        />
        <FormContainer>
          <BaseForm onSubmit={handleSubmit(this.onSubmit)}>
            <Row gutter={24}>
              <Col xs={24}>
                <Field
                  component={TextInput}
                  name="name"
                  type="text"
                  label="Name *"
                  placeholder={"Insert the  name of client"}
                />
              </Col>
            </Row>
          </BaseForm>
        </FormContainer>
      </React.Fragment>
    );
  }
}

ManageAdminPage = reduxForm({
  form: "manage_admin_form",
  validate: validations,
})(ManageAdminPage);

export default withLocalize(ManageAdminPage);
